import styled from 'styled-components/macro';
import { fontSize04 } from '../../../styling/fonts';

type Props = {
  $isValid?: boolean;
  $isInvalid?: boolean;
};

export const Checkbox = styled.input.attrs(() => ({ type: 'checkbox' }))<Props>`
  height: ${fontSize04};
  width: ${fontSize04};
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
  }
`;
